import React from 'react';
import 'intersection-observer';
import millennials from '../images/infographic1/A-millennials.png';
import boomers from '../images/infographic1/A-Boomers.png';
import genx from '../images/infographic1/A-GenX.png';
import homeowners from '../images/infographic1/B-homeowners.png';
import mobile from '../images/infographic1/B-MobileApp.png';
import rent from '../images/infographic1/B-Rent.png';
import staticChart from '../images/infographic1/B-Static.png';
import suburbs from '../images/infographic1/B-Suburbs.png';
import raise from '../images/infographic1/C-Raise.png';
import employment from '../images/infographic1/C-Employment.png';
import plate from '../images/infographic1/D-Plate.png';
import line from '../images/infographic1/D-line.png';
import stats from '../images/infographic1/D-stats.png';
import laptopStats from '../images/infographic1/D-stats-1024.png';
import retirement from '../images/infographic1/E-retirement.png';
import laptopRetirement from '../images/infographic1/E-retirement-1024.png';
import shield from '../images/infographic1/E-shield.png';
import children from '../images/infographic1/E-children.png';
import world from '../images/infographic1/F-world.png';
import wrench from '../images/infographic1/F-wrench.png';
import eye from '../images/infographic1/F-eye.png';
import introHeader from '../images/infographic1/intro-header.png';
import popup1 from '../images/infographic1/popup1.png';
import popup2 from '../images/infographic1/popup2.png';
import popup3 from '../images/infographic1/popup3.png';
import popup4 from '../images/infographic1/popup4.png';
import downArrow from '../images/infographic1/down-arrow.png';

import '../stylesheets/D.scss';
import Infographic from './Infographic';
import InfographicMobile from './InfographicMobile';
import Sources from './Sources';
import Button from './Button';
import copy from '../copy/InfographicOneCopy';

function D() {
  return (
    <article className="d">
      {window.innerWidth > 425 ? (
        <>
          <div className="infographic-container" id="intro">
            <img className="intro-image" src={introHeader} alt="header" />
            <div className="intro-titles">
              <h1>Generations of Wealth</h1>
              <h2>
                How <span className="blue">Millennials</span>, <span className="pink">Gen X</span>, and <span className="yellow">Baby Boomers</span> spend, save, and think about
                wealth
              </h2>
            </div>
            <img className="down-arrow" src={downArrow} alt="down arrow" />
          </div>

          <Infographic
            sectionName={'A'}
            copy={copy}
            sectionNumber={1}
            images={[{ image: millennials, tooltip: false }, { image: genx, tooltip: false }, { image: boomers, tooltip: true }]}
            top={'30%'}
            popup={popup1}
            x={'30%'}
            y={'170%'}
            popupId={'popup1'}
            link={
              'https://ad.doubleclick.net/ddm/trackclk/N781268.8535CNNNETWORK/B23177801.261209246;dc_trk_aid=457310378;dc_trk_cid=121227925;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua='
            }
          />
          <Infographic
            sectionName={'B'}
            copy={copy}
            sectionNumber={2}
            images={[
              { image: homeowners, tooltip: true, animation: true, direction: [false, false, false, true], distance: '50px' },
              { image: rent, tooltip: false, animation: true, direction: [false, false, false, true], distance: '50px' },
              { image: mobile, tooltip: false, animation: true, direction: [false, false, false, true], distance: '50px' },
              { image: suburbs, tooltip: false, animation: true, direction: [false, false, false, true], distance: '50px' },
              { image: staticChart, tooltip: false, animation: true, direction: [false, false, false, true], distance: '50px' },
            ]}
            popup={popup2}
            x={'25%'}
            y={'10%'}
            popupId={'popup2'}
            link={
              'https://ad.doubleclick.net/ddm/trackclk/N781268.8535CNNNETWORK/B23177801.261209249;dc_trk_aid=457308465;dc_trk_cid=121227925;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua='
            }
          />
          <Infographic
            sectionName={'C'}
            copy={copy}
            sectionNumber={3}
            images={[
              { image: raise, tooltip: false, animation: true, direction: [false, false, true, false], distance: '50px' },
              { image: employment, tooltip: false, animation: true, direction: [false, false, true, false], distance: '50px' },
            ]}
          />
          <Infographic
            sectionName={'D'}
            copy={copy}
            sectionNumber={4}
            images={[{ image: plate, tooltip: true }, { image: line, tooltip: false }, { image: stats, tooltip: false }]}
            laptopImages={[{ image: plate, tooltip: true }, { image: line, tooltip: false }, { image: laptopStats, tooltip: false }]}
            popup={popup3}
            x={'200%'}
            y={'10%'}
            popupId={'popup3'}
            link={
              'https://ad.doubleclick.net/ddm/trackclk/N781268.8535CNNNETWORK/B23177801.261209252;dc_trk_aid=457309253;dc_trk_cid=121227925;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua='
            }
          />
          <Infographic
            sectionName={'E'}
            copy={copy}
            sectionNumber={5}
            images={[
              { image: children, tooltip: false },
              { image: shield, tooltip: true, animation: true, direction: [false, false, true, false], distance: '50px' },
              { image: retirement, tooltip: false },
            ]}
            laptopImages={[{ image: children, tooltip: false }, { image: shield, tooltip: true }, { image: laptopRetirement, tooltip: false }]}
            x={'25%'}
            y={'10%'}
            popup={popup4}
            popupId={'popup4'}
            link={
              'https://ad.doubleclick.net/ddm/trackclk/N781268.8535CNNNETWORK/B23177801.261209447;dc_trk_aid=457310381;dc_trk_cid=121227925;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua='
            }
          />
          <Infographic
            sectionName={'F'}
            copy={copy}
            sectionNumber={6}
            images={[{ image: world, tooltip: false }, { image: wrench, tooltip: false }, { image: eye, tooltip: false }]}
          />

          <Button
            message={'What is wealth to you?'}
            link={
              'https://ad.doubleclick.net/ddm/trackclk/N781268.8535CNNNETWORK/B23177801.261209450;dc_trk_aid=457308123;dc_trk_cid=121227925;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua='
            }
          />
          <Sources />
        </>
      ) : (
        <InfographicMobile />
      )}
    </article>
  );
}

export default D;
